import React from 'react';
import {
    Input,
    Icon,
    Col, Row,
    Table,
    Pagination,
    Button,
    Tooltip,

    Form,
    Modal
} from 'antd';
const {Search} = Input;
import AsyncAppHOCFN  from '../AsyncAppHOC'
import style from './index.less'
const FormItem=Form.Item;
import {imgbaseurl} from '../config';

import {getOptionsByDictionary,changeByDictionary} from '../utils/common';
const formItemLayout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 },
};
import IntlWrap from '../intlWrap'
@Form.create({})
class Product extends React.Component {
    /**
     * 构造方法
     * @param props
     */
    static getDerivedStateFromProps(nextProps) {
        // Should be a controlled component.
        if ('visible' in nextProps) {

            return {
                visible:nextProps.visible || false,
            };
        }
        return null;
    }

    constructor(props) {
        super(props);
        const visible = props.visible ||false;
        this.state={

            visible,
            params:{
                page:{
                    pageNumber: 1,
                    pageSize: 10,
                },
                customerId:props.customerId ||'',
                productNo: '',
                productName:''
            },
            selectedRowKeys:[],
            selectedRows:[],
            total:0,
            tableDateList:[]
        }
    }



    /**
     * 组件渲染之后执行
     */
    componentDidMount() {
        let {params}=this.state;
        this.dispatchRequet(params)
    }
    // openModal=()=>{
    //     this.setState({
    //         visible: true,
    //         selectedRowKeys:[],
    //         selectedRows:[],
    //     });
    // };
    hideModal = () => {
        let {close}=this.props
        if(close&&typeof close=="function"){
            close()
        }

    };
    // clear=()=>{
    //     let {onChange}=this.props;
    //     if(onChange){
    //         onChange('');
    //         this.setState({
    //             valueStr:''
    //         })
    //     }
    // };
    confirm=()=>{
        let {onChange}=this.props;
        let {selectedRows}=this.state;
        if(onChange&&selectedRows.length){
            onChange(selectedRows)
        }
        this.hideModal()
    };
    /**
     * 第几页事件
     * @param current
     * @param limit
     */
    handlePageNumChange = (current, limit) => {
        let {params}=this.state;
        params.page = {
            pageSize:limit,
            pageNumber:current
        };
        this.setState({
            selectedRowKeys:[],
            selectedRows:[],
            params
        });
        this.dispatchRequet(params)
    }


    /**
     * 每页记录数事件
     * @param current
     * @param limit
     */
    handlePageSizeChange = (current, limit) => {
        let {params}=this.state;
        params.page = {
            pageSize:limit,
            pageNumber:current
        };
        this.setState({
            selectedRowKeys:[],
            selectedRows:[],
            params
        });
        this.dispatchRequet(params)
    };
    /**
     * 查询按钮点击事件
     */
    handleSearch = () => {

        this.props.form.validateFields(['warehouseName'],(err, values) => {
            if(!err){
                let {warehouseName}=values;
                let params={
                    page:{
                        pageNumber: 1,
                        pageSize: 10,
                    },
                    productName:warehouseName,
                    productNo:warehouseName
                };
                this.dispatchRequet(params);// eslint-disable-line react/destructuring-assignment
                this.setState({
                    params,
                    selectedRowKeys:[],
                    selectedRows:[],
                    total:0
                })
            }
        });
    }
    dispatchRequet=(params)=>{
        const {dispatch,getDate,locale} = this.props;
        getDate(
            {
                name:'getProductDate',
                url:'http://192.168.3.80:10201/api/101120102',
                params:params,
                locale
            },()=>{
                let {getProductDate}=this.props;
                this.setState({
                    tableDateList:getProductDate&&getProductDate.posts&&getProductDate.posts.page&&getProductDate.posts.page.content||[],
                    total:getProductDate&&getProductDate.posts&&getProductDate.posts.page&&getProductDate.posts.page.totalRecords||0,
                })
            })
    }
    render(){
        let {visible,params,selectedRowKeys,tableDateList,total}=this.state;
        let {page}=params;
        const columnV=[
            {
                title: '序号',
                render:(text, record, index)=>{
                    return index-0+1
                },
                width: 80,
            },
            {
                title:'产品图片',
                key: 'productNo',
                dataIndex:'productNo',
                width: 100,

                render:(text, record, index)=>{
                    let {picPath,picKey}=record;
                    if(picPath&&picKey){
                        return <img src={imgbaseurl+picPath+picKey} style={{width:50,height:'auto'}} />
                    }else{
                        return null
                    }
                },
            },
            {
                title:'产品编码',
                key: 'productNo',
                dataIndex:'productNo',
                width: 150,
                textWrap: 'word-break',
            },
            {
                title:'产品名称',
                key: 'productName',
                dataIndex:'productName',
                width: 150,
                textWrap: 'word-break',
            },
            {
                title:'规格型号',
                key: 'specType',
                dataIndex:'specType',
                textWrap: 'word-break',
                width: 100,
            },
            {
                title:'单位',
                key: 'unitName',
                dataIndex:'unitName',
                textWrap: 'word-break',
                width: 100,
            },
            {
                title:'采购参考价',
                key: 'defaultPricePurchase',
                dataIndex:'defaultPricePurchase',
                textWrap: 'word-break',
                width: 100,
            },
            {
                title:'币种',
                key: 'address',
                dataIndex:'address',
                textWrap: 'word-break',
                width: 100,
            },
            {
                title:'品牌',
                key: 'brandName',
                dataIndex:'brandName',
                textWrap: 'word-break',
                width: 100,
            },

        ];
        let rowSelection ={ rowSelection:{
                selectedRowKeys,
                onChange: (selectedRowKeys, selectedRows) => {
                    this.setState({
                        selectedRowKeys, selectedRows
                    });
                }
            }};
        let {isMultiselect=false,disabled=false}=this.props;
        if(!isMultiselect){
            rowSelection={}
        }
        const { getFieldDecorator } = this.props.form;
        const loading=this.props.loading;
        return(

                <Modal
                    title=""
                    visible={visible}
                    onOk={this.confirm}
                    onCancel={this.hideModal}
                    okText="确认"
                    cancelText="取消"
                    width='800px'
                >
                    <Form
                        className="ant-advanced-search-form"
                    >
                        <Row gutter={{ md: 8, lg: 24, xl: 48 }}>
                            <Col sm={{span:24}} md={{span:16}} lg={{span:16}} xl={{span:16}}  key ='1'>
                                <FormItem {...formItemLayout} label={<></>}  colon={false} >
                                    {getFieldDecorator(`warehouseName`)(
                                        <Search
                                            placeholder="产品编码/名称模糊查询"
                                            enterButton="查询"
                                            onSearch={this.handleSearch}
                                            disabled={disabled}
                                        />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>
                    <Table
                        {...rowSelection}
                        loading={loading}
                        pagination = {false}
                        bordered
                        columns={columnV}
                        dataSource={tableDateList}
                        scroll={{ x: '100%' ,y: 300}}
                        onRow={record => {
                            return {
                                onDoubleClick: event => {
                                    let {onChange}=this.props;
                                    if(onChange&&typeof onChange=="function"){
                                        let {warehouseId,warehouseName}=record;
                                        console.log([{warehouseId,warehouseName}],'asdasdasda')
                                        onChange([record])
                                    }
                                    this.hideModal()

                                },
                            }}}
                    />
                    <div className="pagina" style={{marginTop:'20px'}}>
                        <Pagination
                            showSizeChanger
                            showQuickJumper
                            onChange={this.handlePageNumChange}
                            onShowSizeChange={this.handlePageSizeChange}
                            pageSize={page.pageSize}
                            current={page.pageNumber}
                            showTotal={total => `共 ${total} 条`}
                            total={total}
                        />
                    </div>
                </Modal>
        )
    }
}

export default IntlWrap(AsyncAppHOCFN(Product));